import { RightOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Space, Typography } from 'antd';
import React, { ReactElement, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { HeaderInfoContext } from '../providers/HeaderInfoProvider';

const { Text } = Typography;

const Container = styled.div`
  box-sizing: border-box;

  flex-shrink: 0;
  width: 100%;
  height: ${p => p.theme.controlHeight + 2 * p.theme.paddingXXS}px;
  padding: ${p => p.theme.paddingXXS}px ${p => p.theme.paddingXXS}px;

  display: flex;
  align-items: center;
`;

const ExpandButton = styled(Button) <{ $expanded: boolean }>`
  min-width: 1px;
  flex-grow: 1;

  text-align: start;
  padding: ${p => p.theme.paddingXXS}px;

  .anticon.anticon-right {
    transform: rotate(${p => p.$expanded ? 90 : 0}deg);
    transition: all ${p => p.theme.motionDurationMid} ${p => p.theme.motionEaseInOut};
  }
`;

export interface HeaderProps {
  expanded: boolean;
  onExpandedChangeRequested?(expanded: boolean): void;
}

export default function Header({ expanded, onExpandedChangeRequested }: HeaderProps): ReactElement {
  const [{ actions }] = useContext(HeaderInfoContext);
  const { t } = useTranslation();

  return (
    <Container>
      <ExpandButton type="link" $expanded={expanded} aria-label={expanded ? t('collapseFragment') : t('expandFragment')} aria-expanded={expanded} onClick={() => onExpandedChangeRequested?.(!expanded)}>
        <Space>
          <RightOutlined />
          <Text strong aria-label={t('misc.title')}><UserOutlined /> {t('fragmentName')}</Text>
        </Space>
      </ExpandButton>
      {expanded && actions}
    </Container>
  );
}